/**
 * Оболонка довідкового центру (ч.1000).
 *
 * Маршрут `/help` ОДИН на всіх — і для гостя, і для залогіненого. Спроба
 * оголосити його двічі (публічний + вкладений у AppLayout) не спрацювала:
 * React Router обирає точніший збіг, і абсолютний «/help» завжди вигравав
 * у вкладеного «help», тож залогінений лишався без шапки й меню.
 *
 * Тому оболонку обирає ця сторінка:
 *  - залогінений з активним тенантом — повний макет сайту (шапка + меню),
 *    як просив власник;
 *  - усі інші (гість, або ще не обраний тенант) — та сама стаття з простою
 *    шапкою і кнопкою «увійти». Довідник лишається публічним: клієнт шукає
 *    відповідь ДО звернення у підтримку, а посилання можна переслати будь-кому.
 */
import { useNavigate } from 'react-router-dom';

import { useAuth } from '@/auth/store';
import AppLayout from '@/layouts/AppLayout';
import BrandLogo from '@/shared/components/BrandLogo';

import HelpPage from './HelpPage';

export default function PublicHelp() {
  const navigate = useNavigate();
  const token = useAuth((s) => s.sessionActive);
  const tenantId = useAuth((s) => s.activeTenantId);

  // ч.1419: без `key` за статтею — перемонтування скидало розділ, пошук і вид матеріалу при кожному
  // кліку по списку. Статтю сторінка бере з адреси сама.
  const page = <HelpPage />;

  // Макет вимагає активного тенанта (меню, перемикач, права). Без нього
  // показуємо гостьову версію, а не ламану шапку.
  if (token && tenantId) return <AppLayout>{page}</AppLayout>;

  return (
    <div className="public-help">
      <header className="public-help__bar">
        {/* ч.1425: логотип веде на головну сторінку сайту: посиланням, бо `/` віддає не застосунок. */}
        <a href="/" className="public-help__logo" aria-label="Облік+ — на головну"><BrandLogo /></a>
        <button type="button" className="public-help__brand"
          onClick={() => navigate('/help')}>
          Довідка
        </button>
        <button type="button" className="primary"
          onClick={() => navigate(token ? '/select-tenant' : '/login')}>
          {token ? 'до системи' : 'увійти'}
        </button>
      </header>
      {page}
    </div>
  );
}
